import React, { useState, useEffect } from 'react'
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
    // --- State Management ---
    const [userData, setUserData] = useState(null); // Initialize with null
    const [loadingCount, setLoadingCount] = useState(true); // Renamed for clarity (loadincount -> loadingCount)
    const [username, setUsername] = useState("");
    const [role, setRole] = useState("");
    
    // State to manage which parent menu item is open
    const [openMenu, setOpenMenu] = useState({}); 

    // Function to toggle a submenu by its unique key
    const toggleMenu = (key) => {
        setOpenMenu(prevOpenMenu => ({
            ...prevOpenMenu,
            [key]: !prevOpenMenu[key]
        }));
    };

    // --- Data Fetching Logic ---
    useEffect(() => {
        // Correct usage of onAuthStateChanged: listen once and clean up
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
            // Since fetchData1 depends on userData, it's better to call it after setUserData
            // or use useEffect with userData dependency, which we'll do below.
        });
        return () => unsubscribe(); // Cleanup subscription
    }, []); 

    useEffect(() => {
        const fetchData1 = async () => {
            try {
                // Check for user and ensure loading is only done once
                if (userData && loadingCount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setRole(docSnap.data().role);
                        setUsername(docSnap.data().username);
                        setLoadingCount(false)
                    }
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        }
        
        fetchData1();
    }, [userData, loadingCount]); // Re-run when userData or loadingCount changes

    // --- Render ---
    return (
        <div>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* Brand Logo */}
                <a href="index3.html" className="brand-link">
                    <img src={window.location.origin + '/user.jpg'} alt="User" className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
                    <span className="brand-text font-weight-light">{username} </span>
                </a>
                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            
                            {/* Static Links */}
                            <li className="nav-item">
                                <a href="/home" className="nav-link">
                                    <i className="nav-icon fa fa-home" />
                                    <p>Home</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/approvals" className="nav-link">
                                    <i className="nav-icon fa fa-edit" />
                                    <p>Approvals</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/room-cleaning" className="nav-link">
                                    <i className="nav-icon fa fa-close" />
                                    <p>Cleaning Rooms</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/room-cleaned" className="nav-link">
                                    <i className="nav-icon fa fa-check" />
                                    <p>Cleaned Rooms</p>
                                </a>
                            </li>
                            

                            {/* --- REPORT SUBMENU IMPLEMENTATION --- */}
                            {/* <li className="nav-header" style={{ fontWeight: "700" }}>Report</li> */}

                            {/* Parent Menu Item - Toggle is added here */}
                            <li 
                                className={`nav-item ${openMenu['report'] ? 'menu-open' : ''}`}
                            >
                                <a 
                                    href="#reports" 
                                    className="nav-link"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent page reload
                                        toggleMenu('report');
                                    }}
                                >
                                    <i className="nav-icon fa fa-chart-bar" /> {/* Changed icon for better visualization */}
                                    <p>
                                        Reports 
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                
                                {/* Submenu List - Conditional rendering based on state */}
                                <ul className="nav nav-treeview" style={{ display: openMenu['report'] ? 'block' : 'none' }}>
                                    <li className="nav-item">
                                        <a href="/room-type-wise-online-bookings" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Room Type Wise Online</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/receptionist-report" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Receptionist Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/all-booking-report" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>All Booking Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/datewise-bookings" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Datewise Booking</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/paymode-wise-report" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Payment Mode Wise</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/booking-type-report" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Booking Type Wise</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/pending-payments" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Pending Payments</p>
                                        </a>
                                    </li>
                                    {/* <li className="nav-item">
                                        <a href="/planwise-booking-count" className="nav-link">
                                            <i className="fa fa-file nav-icon" />
                                            <p>Planwise Booking Count</p>
                                        </a>
                                    </li> */}
                                </ul>
                            </li>
                            
                            {/* --- RESERVATIONS SUBMENU IMPLEMENTATION --- */}
                            {/* <li className="nav-header" style={{ fontWeight: "700" }}>Reservations</li> */}

                            {/* Parent Menu Item - Toggle is added here */}
                            <li 
                                className={`nav-item ${openMenu['reservations'] ? 'menu-open' : ''}`}
                            >
                                <a 
                                    href="#reservations" 
                                    className="nav-link"
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        toggleMenu('reservations');
                                    }}
                                >
                                    <i className="nav-icon fa fa-book" /> 
                                    <p>
                                        Reservations Mgmt
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                
                                {/* Submenu List */}
                                <ul className="nav nav-treeview" style={{ display: openMenu['reservations'] ? 'block' : 'none' }}>
                                    <li className="nav-item">
                                        <a href="/live-bookings" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Live Bookings</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/checkout-history" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Checkout History</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/damage-notes" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Damage Notes</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/pending-bookings" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Pending Bookings Notes</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/view-future-bookings" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Advance Bookings</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/mobile-nowise-bookings" className="nav-link">
                                            <i className="fa fa-circle-o nav-icon" />
                                            <p>Mobile No Wise Bookings</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            
                            {/* --- MASTER SUBMENU IMPLEMENTATION --- */}
                            {/* <li className="nav-header" style={{ fontWeight: "700" }}>Master</li> */}

                            <li 
                                className={`nav-item ${openMenu['master'] ? 'menu-open' : ''}`}
                            >
                                <a 
                                    href="#master" 
                                    className="nav-link"
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        toggleMenu('master');
                                    }}
                                >
                                    <i className="nav-icon fa fa-cubes" /> 
                                    <p>
                                        Hotel Masters
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                
                                <ul className="nav nav-treeview" style={{ display: openMenu['master'] ? 'block' : 'none' }}>
                                    <li className="nav-item">
                                        <a href="/room-types" className="nav-link">
                                            <i className="fa fa-book nav-icon" />
                                            <p>Room Types</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/room-type-images" className="nav-link">
                                            <i className="fa fa-book nav-icon" />
                                            <p>Room Types Images</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/room-details" className="nav-link">
                                            <i className="fa fa-table nav-icon" />
                                            <p> Room Details</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/rate-plans" className="nav-link">
                                            <i className="fa fa-pencil nav-icon" />
                                            <p> Rate Plans</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/room-tarrif" className="nav-link">
                                            <i className="fa fa-money nav-icon" />
                                            <p> Room Tarrifs</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/room-services" className="nav-link">
                                            <i className="fa fa-cube nav-icon" />
                                            <p> Room Services</p>
                                        </a>
                                    </li>
                                     <li className="nav-item">
                                        <a href="/payment-modes" className="nav-link">
                                            <i className="fa fa-credit-card nav-icon" />
                                            <p> Payment Modes</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/booking-types" className="nav-link">
                                            <i className="fa fa-globe nav-icon" />
                                            <p> Booking Types</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            {/* Remaining static links (OTA Mgmt converted to static) */}
                            {/* <li className="nav-header" style={{ fontWeight: "700" }}>OTA Mgmt</li> */}
                             <li className="nav-item">
                                <a href="/website-rooms" className="nav-link">
                                    <i className="nav-icon fa fa-globe" />
                                    <p>Website Rooms</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/website-gallery" className="nav-link">
                                    <i className="nav-icon fa fa-globe" />
                                    <p>Website Gallery</p>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a href="/corporate-guest" className="nav-link">
                                    <i className="nav-icon fa fa-users" />
                                    <p>Corporate Guests</p>
                                </a>
                            </li>
                           
                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    )
}
export default Menu